/* eslint-disable arrow-body-style */
import { getAppendix } from '@home/services/studio';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'umi';
import { StudioContext } from '@home/pages/studio/context';
import { getPdfCos } from '@/pages/dashboard/services/dashboard';
import { ENV } from '@home/_config/config';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  config: any;
  gameInfo?: { [key: string]: string; };
  filter: { [key: string]: string; };
  defaultList: IHighlightItem[];
  changeParams: Array<string>;
  filterCond: any;
  highlightCnMap: Record<string, string>;
}

interface IHighlightItem {
  key: string;
  titleEn: string;
  titleCn: string;
  executive_summary: string;
  
}

export default function AppendixWrap(props: IProps) {
  const { className, style, children, filter, gameInfo, ...restProps } = props || {};
  const { date_type: dateType, start_time: startTime, end_time: endTime, } = filter || {};
  const { studioId } = useParams() || ({} as any);
  const [appendixList, setAppendixList] = useState([]);
  const { editPermission } = useContext(StudioContext);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [appendixContent, setAppendixContent] = useState();
  const [clickAddAppendix, setClickAddAppendix] = useState(false);
  const [clickEditAppendix, setClickEditAppendix] = useState(false);
  // 受控的环境，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const isControlled = controlledEnv.includes(ENV);

  const processImageUrls = async (appendices: any[]) => {
    return Promise.all(
      appendices.map(async (item) => {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = item.appendix;

        // 选取当前 appendix 内容中的所有 <img> 标签
        const images = wrapper.querySelectorAll("img");  
  
        await Promise.all(
          Array.from(images).map(async (img) => {
            if (img.src) {
              try {
                // 去除 URL 中的查询参数，避免使用过期的签名 URL
                const cleanUrl = img.src.split("?")[0];

                // 重新获取签名 URL
                const signedUrl = await getPdfCos({ url: cleanUrl });

                // 将 <img> 标签的 src 替换为获取的签名 URL
                img.src = signedUrl;
              } catch (error) {
                console.error("图片 URL 解析失败", error);
              }
            }
          })
        );

        // 更新所有图片后返回新的 appendix 内容
        return { ...item, appendix: wrapper.innerHTML }; 
      })
    );
  };

  // 获取高亮报告数据
  const fetchData = async () => {
    const params = {
      studio_code: studioId,
      unified_id: gameInfo?.edition_unified_id,
      period: dateType,
      start_date: moment(startTime).format("YYYY-MM-DD"),
      end_date: moment(endTime).format("YYYY-MM-DD"),
    };
  
    try {
      setLoading(true);
      // 获取原始附录数据
      const { appendices } = await getAppendix(params);

      let finalAppendices = appendices;
      
      // 正式&预发 需要重新处理过期的图片 URL
      if (isControlled) {
        finalAppendices = await processImageUrls(appendices);
      }
      setAppendixList(finalAppendices);
      setError(false);
    } catch (error) {
      setError(true);
      console.error("Failed to fetch appendix:", error);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    if (!dateType) return;
    fetchData();
    setLoading(true);
  }, [filter, studioId, gameInfo, dateType]);

  return (
    <>
      {React.Children.map(children, (child: any) => React.cloneElement(
        child,
        {
          ...restProps,
          appendixList,
          filter,
          loading,
          error,
          fetchData,
          gameInfo,
          editPermission,
          setAppendixContent,
          appendixContent,
          clickAddAppendix,
          setClickAddAppendix,
          clickEditAppendix,
          setClickEditAppendix
        }
      ))}
    </>
  );
}